var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('number',{attrs:{"from":0,"to":_vm.number,"duration":_vm.duration,"format":_vm.formatNumber}})}
var staticRenderFns = []

export { render, staticRenderFns }